import { styled } from '@mui/material/styles';

export const UnorderedListStyled = styled('ul', {
  name: 'UnorderedListStyled',
})(() => ({
  overflow: 'auto',
  maxHeight: '15em',
  listStyle: 'none',
  padding: 0,
}));

export const ListItemStyled = styled('li', {
  name: 'ListItemStyled',
})(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'nowrap',
  alignItems: 'center',
  '& span': {
    marginLeft: theme.spacing(1),
  },
  '&::before': {
    width: '1em',
    content: '"•"',
    color: theme.palette.secondary.dark,
  },
}));

export const HierarchicalItemStyled = styled('li', {
  name: 'HierarchicalItemStyled',
})(({ theme }) => ({
  paddingLeft: '1em',
  marginBottom: theme.spacing(1),
  position: 'relative',
  '&::before': {
    position: 'absolute',
    left: 0,
    top: 0,
    content: '"•"',
    color: theme.palette.secondary.dark,
  },
}));

export const NestedListStyled = styled('ul', {
  name: 'NestedListStyled',
})(({ theme }) => ({
  listStyle: 'none',
  paddingLeft: theme.spacing(2),
  margin: theme.spacing(0.5, 0, 0),
}));

export const NestedItemStyled = styled('li', {
  name: 'NestedItemStyled',
})(({ theme }) => ({
  paddingLeft: '1em',
  position: 'relative',
  marginBottom: theme.spacing(0.25),
  '&::before': {
    position: 'absolute',
    left: 0,
    top: 0,
    content: '"◦"',
    color: theme.palette.text.secondary,
  },
}));

export const SubNestedItemStyled = styled('li', {
  name: 'SubNestedItemStyled',
})(({ theme }) => ({
  paddingLeft: '1em',
  position: 'relative',
  '&::before': {
    position: 'absolute',
    left: 0,
    top: 0,
    content: '"–"',
    color: theme.palette.text.disabled,
  },
}));
